import { React, useEffect } from "react";
import ArrowImage from "../../images/icons/arrow.svg";
import { Link } from "react-router-dom";
import WhiteHeader from "../../components/Navigation/WhiteHeader";
import homeIcon from "../../images/icons/homevector.svg";

function Corporate() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  let breadcrumbs = [{ name: "Corporate Solutions", href: "/" }];
  return (
    <div>
      <WhiteHeader breadcrumbs={breadcrumbs} />

      <div className="container py-5">
        <h1>Get the most out of the services we offer</h1>
        <strong className="py-3">
          We’re here to Mentor you through life’s financial journey. Tell us
          what you need:
        </strong>
        <div className="row">
          <div className="col-12 col-md-4">
            <div class="row py-3">
              <div className="col-11 col-md-8 mx-3 orange-lite-button black-link">
                <Link to="/memberships">
                  <div className="row py-2">
                    <div className="col-10">Become a member </div>
                  </div>
                </Link>
              </div>

              <div className="col-11 col-md-8 mx-3 blue-lite-button black-link">
                <Link
                  // to="/loans/corporate"
                  to={{
                    pathname: "/solution-details",
                    state: {
                      item: {
                        id: 6,
                        information:
                          '<h3 id="subheader2">Who is this for?</h3>\r\n<p>Explore a variety of corporate loans that are tailor made to match your unique business needs. We understand that you need the opportunity to manage your day to day operations as well as invest in your future.</p>',
                        name: "Corporate Loans",
                        path: "Corporate Solutions",
                        link: "/solutions/corporate_services",
                      },
                    },
                  }}
                >
                  <div className="row py-2">
                    <div className="col-10">Get a loan</div>
                    <div className="col-1">
                      <img
                        loading="lazy"
                        height="15rem"
                        src={ArrowImage}
                        alt=""
                      />
                    </div>
                    <div className="col-1"></div>
                  </div>
                </Link>
              </div>

              <div className="col-11 col-md-8 mx-3 white-dark-button black-link">
                <Link
                  // to="/invest"
                  to={{
                    pathname: "/solution-details",
                    state: {
                      item: {
                        id: 7,
                        information:
                          '<p style="line-height: 35px;">Our Investment Products are for all our members who need investment services from us.</p>',
                        name: "Invest",
                        path: "Corporate Solutions",
                        link: "/solutions/corporate_services",
                      },
                    },
                  }}
                >
                  <div className="row py-2">
                    <div className="col-10">Invest with us</div>
                    <div className="col-1">
                      <img
                        loading="lazy"
                        height="15rem"
                        src={ArrowImage}
                        alt=""
                      />
                    </div>
                    <div className="col-1"></div>
                  </div>
                </Link>
              </div>

              <div className="col-11 col-md-8 mx-3 green-lite-button black-link">
                <Link
                  // to="/insure"
                  to={{
                    pathname: "/solution-details",
                    state: {
                      item: {
                        id: 9,
                        information:
                          '<h3 id="subheader">Who is this for?</h3>\r\n<p style="line-height: 35px; font-size: 20px;">Our insurance services are for all members who need various insurance covers.</p>',
                        name: "Insure",
                        path: "Corporate Solutions",
                        link: "/solutions/corporate_services",
                      },
                    },
                  }}
                >
                  <div className="row py-2">
                    <div className="col-10">Insure</div>
                    <div className="col-1">
                      <img
                        loading="lazy"
                        height="15rem"
                        src={ArrowImage}
                        alt=""
                      />
                    </div>
                    <div className="col-1"></div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="row  mt-2r">
          <div className="col-12 col-md-7">
            <h1 className="pt-5" id="subheader">
              Not interested in this product?{" "}
            </h1>
            <p>
              No worries. Check out our other loan products that may interest
              you
            </p>
            <div className="row py-5">
              <div className="col-12">
                <Link to="/">
                  <button
                    className="btn btn-outline-primary rounded"
                    type="submit"
                  >
                    Try Other Products
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Corporate;
